import { Injectable } from '@angular/core';
import { SessionService } from '../session/session.service';
import { GameInfo } from '../../domain/signals/game-info';
import { BalanceService } from '../../balance/balance.service';
import { TicketHistoryService } from '../ticket-history/ticket-history.service';

@Injectable()
export class BetStartService {

    constructor(public sessionService: SessionService,
                public balanceService: BalanceService,
                public ticketHistoryService: TicketHistoryService) {
    }

    public initializeBetStart(gameInfo: GameInfo, secondsSinceEvent: number = 0) {
        if (gameInfo.State === GameInfo.States.BET_START && gameInfo.Game && gameInfo.Game.BingoGameID > 0) {
            this.sessionService.winner = false;
            this.sessionService.countdown.start(gameInfo.BetAcceptanceTime - secondsSinceEvent);
            this.sessionService.currentBingoGameId = gameInfo.Game.BingoGameID;
            this.sessionService.selectedTipIndex = 0;
            this.sessionService.numbers.length = 0;
            this.sessionService.removeInvalidTickets();
            setTimeout(() => {
                this.balanceService.updateBalance();
                this.ticketHistoryService.fetchHistory();
            }, 5000);
        }
    }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/services/bet-start/bet-start.service.ts